import moment from 'moment';

import { Period } from 'app/shared/services/product-search/constants';

export interface DateRange {
    from: string;
    to: string;
}

export const DEFAULT_REPLENISHMENT_PERIOD: Period = Period.LAST_7_DAYS;

function formatDate(date: moment.Moment): string {
    return date.format('YYYY-MM-DD');
}

function startOfIsoWeek(date: moment.Moment): moment.Moment {
    return date.clone().startOf('isoWeek');
}

function endOfIsoWeek(date: moment.Moment): moment.Moment {
    return date.clone().endOf('isoWeek');
}

export function periodToDateRange(period: string, referenceDate = moment()): DateRange {
    const today = referenceDate.clone().startOf('day');
    const yesterday = today.clone().subtract(1, 'day');

    switch (period) {
        case Period.YESTERDAY:
            return { from: formatDate(yesterday), to: formatDate(yesterday) };
        case Period.LAST_7_DAYS:
            return { from: formatDate(today.clone().subtract(6, 'days')), to: formatDate(today) };
        case Period.LAST_30_DAYS:
            return { from: formatDate(today.clone().subtract(29, 'days')), to: formatDate(today) };
        case Period.LAST_12_MONTHS:
            return { from: formatDate(today.clone().subtract(1, 'year').add(1, 'day')), to: formatDate(today) };
        case Period.PREVIOUS_CALENDAR_WEEK: {
            const previousWeek = today.clone().subtract(1, 'week');
            return {
                from: formatDate(startOfIsoWeek(previousWeek)),
                to: formatDate(endOfIsoWeek(previousWeek))
            };
        }
        case Period.PREVIOUS_CALENDAR_MONTH: {
            const previousMonth = today.clone().subtract(1, 'month');
            return {
                from: formatDate(previousMonth.clone().startOf('month')),
                to: formatDate(previousMonth.clone().endOf('month'))
            };
        }
        case Period.PREVIOUS_CALENDAR_YEAR: {
            const previousYear = today.clone().subtract(1, 'year');
            return {
                from: formatDate(previousYear.clone().startOf('year')),
                to: formatDate(previousYear.clone().endOf('year'))
            };
        }
        case Period.ALL_PAST_DATES:
            return { from: '1970-01-01', to: formatDate(yesterday) };
        case Period.CURRENT_WEEK:
            return { from: formatDate(startOfIsoWeek(today)), to: formatDate(today) };
        case Period.CURRENT_MONTH:
            return { from: formatDate(today.clone().startOf('month')), to: formatDate(today) };
        case Period.CURRENT_YEAR:
            return { from: formatDate(today.clone().startOf('year')), to: formatDate(today) };
        default:
            return periodToDateRange(DEFAULT_REPLENISHMENT_PERIOD, referenceDate);
    }
}
